<template>
    <AppLayout title="My Certificates">
        <div class="container pt-4">

            <!-- Welcome Back Card -->
            <div class="row">
                <div class="col-md-12">
                    <div class="card" id="welcome-card">
                        <div class="card-body py-4">
                            <div class="left">
                                <h2 class="card-title">
                                    My Certificates
                                </h2>
                                <p class="card-text subtitle text-light">View your certificates here.</p>
                            </div>

                        </div>
                    </div>
                </div>
            </div>

            <!-- Certificates Table -->
            <div class="row mt-5">
                <div class="col-md-12">
                    <div class="card">
                        <div class="card-body">
                            <div v-if="certificates && certificates.length > 0" class="table-responsive">
                                <table class="table table-striped table-hover">
                                    <thead class="table-dar">
                                        <tr>
                                            <th>Certificate Number</th>
                                            <th>Type</th>
                                            <th>Program</th>
                                            <th>Issue Date</th>
                                            <th>Expiry Date</th>
                                            <th>Status</th>
                                            <th></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="certificate in certificates" :key="certificate.id">
                                            <td>{{ certificate.certificate_number }}</td>
                                            <td>{{ formatCertificateType(certificate.certificate_type) }}</td>
                                            <td>{{ certificate.program }}</td>
                                            <td>{{ formatDate(certificate.issue_date) }}</td>
                                            <td>{{ formatDate(certificate.expiry_date) }}</td>
                                            <td>
                                                <span class="badge" :class="getStatusBadgeClass(certificate.status)">
                                                    {{ formatStatus(certificate.status) }}
                                                </span>
                                            </td>
                                            <td class="d-flex justify-content-end">
                                                <button @click="viewCertificate(certificate.id)" class="btn btn-sm btn-success px-5" title="View Certificate">
                                                    <i class="fas fa-eye"></i> View
                                                </button>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <div v-else class="text-center py-5">
                                <i class="fas fa-certificate fa-3x text-muted mb-3"></i>
                                <h5 class="text-muted">No Certificates Found</h5>
                                <p class="text-muted">You don't have any certificates yet.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </AppLayout>
</template>

<script setup>
import { ref, computed, onMounted, watch, nextTick } from 'vue';
import { router, usePage } from '@inertiajs/vue3';
import AppLayout from '@/Layouts/AppLayout.vue';

// Props
const props = defineProps({
    certificates: {
        type: Array,
        default: () => []
    }
});

// Methods
const formatDate = (date) => {
    if (!date) return 'N/A';
    return new Date(date).toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'short',
        day: 'numeric'
    });
};

const formatCertificateType = (type) => {
    return type ? type.charAt(0).toUpperCase() + type.slice(1) : 'N/A';
};

const formatStatus = (status) => {
    return status ? status.charAt(0).toUpperCase() + status.slice(1) : 'N/A';
};

const getStatusBadgeClass = (status) => {
    switch (status) {
        case 'active':
            return 'bg-success';
        case 'expired':
            return 'bg-danger';
        case 'revoked':
            return 'bg-warning';
        default:
            return 'bg-secondary';
    }
};

const viewCertificate = (certificateId) => {
    router.visit(`/certificates/${certificateId}`);
};

</script>


<style scoped>
/* Welcome Card */
#welcome-card {
    background: linear-gradient(135deg, #1e9579 0%, #2dd4bf 100%);
    color: white;
    border: none;
    border-radius: 16px;
}

/* Table styling */
.table th {
    font-weight: 600;
    border-top: none;
}

.table-hover tbody tr:hover {
    background-color: rgba(0, 0, 0, 0.025);
}

.btn-sm {
    font-size: 0.875rem;
}

.badge {
    font-size: 0.75rem;
    padding: 0.375rem 0.75rem;
}

.card-header {
    border-bottom: none !important;
}

th {
    color: #1e9579;
    font-weight: 800;
}
</style>
